"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var confirmationMainContentStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        confirmationWrapper: (_a = {
                display: 'flex'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'block',
            },
            _a),
        mainContent: {
            flexGrow: 1,
            paddingLeft: '0',
        },
    });
}, { name: 'Checkout_ConfirmationMainContent' });
exports.default = confirmationMainContentStyles;
